// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FirstEnter_wrapper__9\\+WCP {
    margin: 0 auto;
    display: flex;
    justify-content: center;
}

.FirstEnter_popup__X--KP {
background-color: #ffc843;
width: 70%;
border-radius: 10px;
padding: 15px;
color:#161616;
font-size: 18px;
font-weight: bold;
text-align: center;
position: absolute;
top: 20%; 
}

.FirstEnter_text__V41Mq {
    font-weight: bold;
    margin-bottom: 20px;
}

.FirstEnter_button__JSiU4 {
    background-color: #d49000;
    padding: 10px 20px;
    color:white;
    border-radius: 5px;
    font-weight: bold;
    border: black 2px solid;
}`, "",{"version":3,"sources":["webpack://./src/Components/FirstEnter/FirstEnter.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,aAAa;IACb,uBAAuB;AAC3B;;AAEA;AACA,yBAAyB;AACzB,UAAU;AACV,mBAAmB;AACnB,aAAa;AACb,aAAa;AACb,eAAe;AACf,iBAAiB;AACjB,kBAAkB;AAClB,kBAAkB;AAClB,QAAQ;AACR;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;AAC3B","sourcesContent":[".wrapper {\n    margin: 0 auto;\n    display: flex;\n    justify-content: center;\n}\n\n.popup {\nbackground-color: #ffc843;\nwidth: 70%;\nborder-radius: 10px;\npadding: 15px;\ncolor:#161616;\nfont-size: 18px;\nfont-weight: bold;\ntext-align: center;\nposition: absolute;\ntop: 20%; \n}\n\n.text {\n    font-weight: bold;\n    margin-bottom: 20px;\n}\n\n.button {\n    background-color: #d49000;\n    padding: 10px 20px;\n    color:white;\n    border-radius: 5px;\n    font-weight: bold;\n    border: black 2px solid;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `FirstEnter_wrapper__9+WCP`,
	"popup": `FirstEnter_popup__X--KP`,
	"text": `FirstEnter_text__V41Mq`,
	"button": `FirstEnter_button__JSiU4`
};
export default ___CSS_LOADER_EXPORT___;
